import React from "react";
import Section from "./Section";
import * as content from "../content";

const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function WhenWhere() {
  const { whenWhere: w, calendarMay2026: cal } = content;
  return (
    <Section id="when-where">
      <h2 className="section-title">{w.heading}</h2>
      <div className="when-grid">
        <div>
          <p className="label">{w.ceremonyLabel}</p>
          <p className="prose strong">{w.timeLine}</p>
          <p className="prose venue">{w.venueName}</p>
          {w.addressLines.map((line) => (
            <p key={line} className="prose muted">
              {line}
            </p>
          ))}
        </div>
        <div className="calendar-wrap">
          <p className="calendar-caption">{w.calendarCaption}</p>
          <div className="calendar" role="grid" aria-label={w.calendarCaption}>
            <div className="calendar__row calendar__row--head">
              {weekdays.map((d) => (
                <div key={d} className="calendar__cell calendar__cell--head">
                  {d}
                </div>
              ))}
            </div>
            {cal.weeks.map((week, wi) => (
              <div key={wi} className="calendar__row">
                {week.map((day, di) => {
                  const isHighlight = day === cal.highlightDay;
                  return (
                    <div
                      key={`${wi}-${di}`}
                      className={[
                        "calendar__cell",
                        day == null ? "calendar__cell--empty" : "",
                        isHighlight ? "calendar__cell--highlight" : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      role="gridcell"
                    >
                      {day ?? ""}
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
